import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faCircleDot } from '@fortawesome/pro-regular-svg-icons/faCircleDot';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { faCirclePause } from '@fortawesome/pro-regular-svg-icons/faCirclePause';
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons/faCirclePlay';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faRightFromBracket } from '@fortawesome/pro-regular-svg-icons/faRightFromBracket';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faFastForward } from '@fortawesome/pro-solid-svg-icons/faFastForward';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'antd';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';

interface JobStatusIconProps {
  status: string;
}

export const JobStatusIcon = ({ status }: JobStatusIconProps) => {
  const textColor = useJobStatusTextColor(status);

  let icon;
  switch (status.toLowerCase()) {
    case 'authorized':
    case 'unauthorized':
      icon = <FontAwesomeIcon icon={faBan} color={textColor} />;
      break;
    case 'unauthorized-warning':
      icon = <FontAwesomeIcon icon={faTriangleExclamation} color={textColor} />;
      break;
    case 'bypassed':
      icon = <FontAwesomeIcon icon={faFastForward} />;
      break;
    case 'in progress':
      icon = <FontAwesomeIcon icon={faCirclePlay} color={textColor} />;
      break;
    case 'awaiting caf':
      icon = <FontAwesomeIcon icon={faCirclePause} color={textColor} />;
      break;
    case 'in progress - overrunning':
    case 'conflict':
      icon = <FontAwesomeIcon icon={faCircleExclamation} color={textColor} />;
      break;
    case 'sub contracted':
      icon = (
        <Flex gap={5} vertical>
          <FontAwesomeIcon icon={faClock} />
          <FontAwesomeIcon icon={faRightFromBracket} />
        </Flex>
      );
      break;
    case 'to do':
      icon = <FontAwesomeIcon icon={faCircleDot} color={textColor} />;
      break;
    case 'completed':
    case 'complete':
      icon = <FontAwesomeIcon icon={faCircleCheck} color={textColor} />;
      break;
    default:
      icon = <span>--</span>;
  }

  return icon;
};
